import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

/**
 * Sends /training/all-trainings to the Tayseer training portal instead of the
 * in-app AllTrainingsComponent. The portal is a separate Angular app served at
 * /training (proxied to :4300 in dev), so this has to be a full browser
 * navigation — the Angular router can't reach it.
 */
@Injectable({
  providedIn: 'root',
})
export class TrainingPortalRedirectGuard implements CanActivate {
  canActivate(): boolean {
    // The directory, not '/training/home'. A deep path only resolves if the
    // host has an SPA fallback scoped to /training, and the test server has
    // none: it walks up and answers with the web root's index.html, which is
    // *this* app. Our router then fails to match `training/home`, hits
    // `{ path: '**', redirectTo: 'home' }`, and dumps the user on KGate's home
    // page — so clicking a training link in the sidenav appeared to redirect to
    // /home while typing /training worked.
    //
    // A trailing-slash directory request is served the real /training/index.html
    // by any static host, and Tayseer's own router then redirects '' to 'home'
    // client-side, reaching the same destination without depending on server
    // config. Deep links typed or refreshed directly still need that fallback
    // (see the portal's public/.htaccess).
    //
    // replace(), not href: keeps the redirecting URL out of history so Back
    // doesn't land on it and bounce the user forward again.
    window.location.replace('/training/');
    return false;
  }
}
